module.exports = __webpack_public_path__ + "img/web4.246c72bb.png";